module.exports = __webpack_public_path__ + "d3b3f32fde390d46a2aae585e91070db.png";